import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute, convertToParamMap } from "@angular/router";
import { PagerService } from "../../core/services/pager.service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { enableDebugTools } from "@angular/platform-browser";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: "app-callrates",
  templateUrl: "./callrates.component.html",
  styleUrls: ["./callrates.component.css"],
})
export class CallratesComponent implements OnInit {
  Device;
  CallRateName: any;
  CallRates;
  TeamsCallRates;
  DeviceTypeList;
  CallRateList: any[];
  Countries: any[];
  CallTypeListSkype: any[];
  CallTypeListCisco: any[];
  CallTypeListTeams: any[];
  CurrencyList: any[];
  PeakList: any[];
  successfulData;
  frmCallrates;
  GatewayDetails;
  callrateform;
  DestinationList: any[];
  DestinationValues: any[];
  pager: any = {};
  private allItems: any[];
  pagedItems: any[];
  public dropDownSettings: IDropdownSettings;
  public country = "";
  public Type = "";
  public LoginEnterpriseID = "";
  public Country = "";
  public DeviceType;
  public Role = "";
  dataLoader: boolean;
  theFile: any;
  addModifyHostNamesForm: FormGroup;
  public CallType = "";
  dlstCallType: "";
  dlscallType: "";
  CallTypeNationalFlag: Boolean = true;
  CallTypeInterNationalFlag: Boolean = true;
  CallTypeTeamsFlag:Boolean = false;
  DestinationCoutryCity: any[];
  DestinationCountryCode: any[];
  DestinationSelectedCoutryCity: any[];
  DestinationSeletedCountryCode: any[];
  TeamsDestinationCountryCity: any;
  TeamsSelectedDestinationCountryCity: any;

  constructor(
    private router: Router,
    private capservice: CAPService,
    private fb: FormBuilder,
    private _avRoute: ActivatedRoute,
    private pagerService: PagerService
  ) {
    this.LoginEnterpriseID = capservice.enterpriseid;
    this.Role = capservice.Role;
    this.Country = capservice.country;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == undefined) {
      // $location.path("/LoginInvalid");
      // $route.reload();
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit(): void {
    this.dataLoader = true;
    this.dropDownSettings = {
      itemsShowLimit: 3,
      idField: "label_id",
      allowSearchFilter: true,
      textField: "label",
      selectAllText: "Check All",
      unSelectAllText: "UnCheck All",
      maxHeight: 100,
      searchPlaceholderText: "Search",
      clearSearchFilter: true,
      noDataAvailablePlaceholderText: "No data available",
    };
    this.successfulData = {
      Id: "",
      ID1: "",
      ID: "",
      CallRateName: "",
      Country: "",
      CallType: "",
      currencyName: "",
      Currency: "",
      RatePerMinute: "",
      PeakOnOff: "",
      InitMins: "",
      InitCharge: "",
      AddMins: "",
      AddCharge: "",
      destinationName: "",
      destinationId: "",
      DeviceType: "",
      EnterpriseID: "",
      strType: "",
      TelcoId: "",
      RateId: "",
      SourceCountry: "",
      DestinationCountry: "",
      DestinationCountryCode: "",
      DestinationCountryCity: "",
      CityCode: "",
    };
    this.CallRates = {
      CallRateName: "",
      Country: "",
      CallType: "",
      currencyName: "",
      RatePerMinute: "",
      PeakOnOff: "",
      InitMins: "",
      InitCharge: "",
      AddMins: "",
      AddCharge: "",
      Currency: "",
      destinationName: "",
      destinationId: "",
      DeviceType: "",
      EnterpriseID: "",
      strType: "",
      TelcoId: "",
      RateId: "",
      SourceCountry: "",
      DestinationCountry: "",
      DestinationCountryCode: "",
      DestinationCountryCity: "",
      CityCode: "",
    };
    this.TeamsCallRates = {
      ID: "",
      currencyName: "",
      InitMins: "",
      InitCharge: "",
      AddMins: "",
      AddCharge: "",
      DeviceType: "",
      strType: "",
      SourceCountry: "",
      DestinationCountry: "",
      DestinationCountryCode: "",
      DestinationCountryCity: "",
      CityCode: "",
    };
    this.addModifyHostNamesForm = this.fb.group({
      facility: ["", Validators.required],
      domain: ["", Validators.required],
      device: ["", Validators.required],
      hostName: ["", Validators.required],
      inputFile: "",
    });
    this.GatewayDetails = {
      Name: "",
    };
    this.DeviceTypeList = [
      // { name: 'Skype', },
      { name: "Cisco" },
      { name: "Teams" },
    ];
    // this.CallTypeListSkype = [{
    //   name: 'Local Calls',
    // }, {
    //   name: 'National Calls',
    // }, {
    //   name: 'Internal Calls',
    // }, {
    //   name: 'International Calls',
    // }, {
    //   name: 'Mobile Calls',
    // }, {
    //   name: 'Incoming Calls',
    // }]
    // this.CallTypeListCisco = [{
    //   name: 'Local',
    // }, {
    //   name: 'National',
    // }, {
    //   name: 'Internal',
    // }, {
    //   name: 'International',
    // }, {
    //   name: 'Mobile',
    // }, {
    //   name: 'Incoming',
    // }]
    // this.CallTypeListTeams = [{
    //   name: 'Local',
    // }, {
    //   name: 'National',
    // },
    // {
    //   name: 'International',
    // }, {
    //   name: 'Incoming',
    // }, {
    //   name: 'Toll free'
    // }]
    this.CiscoCallRateType("CallRate", "Cisco");
    this.TeamsCallRateType("CallRate", "Teams");
    this.GetCountryList();
    this.DropdownValues();
    this.AudiLogin();
  }

  getTemplate(callRate) {
    if (
      callRate.Id == this.successfulData.selected.Id &&
      callRate.destinationName == this.successfulData.selected.destinationName
    ) {
      return "edit";
    } else {
      return "displayNew";
    }
  }
  TeamsgetTemplate(callRate) {
    if (callRate.ID == this.successfulData.selected.ID) {
      return "edit";
    } else {
      return "displayNew";
    }
  }

  AudiLogin() {
    this.capservice
      .AudiLogin("CallRates", this.LoginEnterpriseID)
      .subscribe((data) => {});
  }
  Destination() {
    //this.dataLoader = true;
    var MultiDestiantionObj = { MultiDestinationArray: [] };
    this.DestinationValues = []
    this.capservice.GetVoiceAdminDetails(this.Device, "DestinationAreaCode", this.country).subscribe(data => {
      this.DestinationList = data
      for (var i = 0; i < data.length; i++) {
        var Destination = { label_id: data[i].destinationId, label: data[i].destinationName }

          MultiDestiantionObj.MultiDestinationArray.push(Destination);
        }
        this.DestinationList = MultiDestiantionObj.MultiDestinationArray;
        this.dataLoader = false;
      });
  }
  validateNumber(e: any) {
    let input = String.fromCharCode(e.charCode);
    const reg = /^(\d{1,5}|\d{0,5}\.\d{1,2})$/;

    if (!reg.test(input)) {
      e.preventDefault();
      alert("Please enter numeric values only");
    }
  }
  validateDecimalNumber(e: any) {
    let input = String.fromCharCode(e.charCode);
    // const reg = /^[\d+\.\d{0,2}+$]/;
    const reg = /^[0-9.]+$/; ///[((\d+)((\.\d{1,2})?))$]/;

    if (!reg.test(input)) {
      e.preventDefault();
      alert("Please enter numeric values only");
    }
  }
  DeviceTypeEvent(event: any) {
    debugger;
    this.dataLoader = true;
    this.ClearDevice();
    this.Device = event.target.value;
    this.Destination();
    this.CallTypeTeamsFlag = false;

    if (
      this.Device == "Skype" ||
      this.Device == "Cisco" ||
      this.Device == "Teams"
    ) {
      $("#AlertForAccess").css("display", "none");

      if (this.Device == "Skype") {
        $("#CallRateCommon").css("display", "block");
        $("#TeamsCallRate").css("display", "none");
        $("#CallRateSkype").css("display", "block");
        $("#CallRateSubmit").css("display", "block");
        $("#CallrateDetailsSkype").css("display", "block");
        $("#CallrateDetailsCisco").css("display", "none");
        $("#divCallrateDetails").css("display", "block");
        $("#divskype").css("display", "block");
      } else if (this.Device == "Cisco") {
        $("#CallRateCommon").css("display", "block");
        $("#TeamsCallRate").css("display", "none");
        $("#TeamsCallRateSubmit").css("display", "none");
        $("#CallRateSkype").css("display", "block");
        $("#CallRateSubmit").css("display", "block");
        $("#CallrateDetailsSkype").css("display", "none");
        $("#CallrateDetailsCisco").css("display", "block");
        $("#divCallrateDetails").css("display", "block");
        $("#divskype").css("display", "none");
        $("#uploadhr").css("display", "none");
        $("#divProjectDetailsCommonupload").css("display", "none");
        // $('#divCallrateDetails').css("display", 'none');
        $("#TeamsBulkUpload").css("display", "none");
        $("#TeamsCallRateSubmit").css("display", "none");

        // OnInit Methods Loading
        this.LoadData();
      }
      // else if (this.Device == 'Teams') {
      //   $('#CallRateCommon').css("display", 'block');
      //   $('#CallRateSkype').css("display", 'block');
      //   $('#CallRateSubmit').css("display", 'block');
      //   $('#CallrateDetailsSkype').css("display", 'block');
      //   $('#CallrateDetailsCisco').css("display", 'none');
      //   $('#divCallrateDetails').css("display", 'block');
      //   $('#divskype').css("display", 'none');
      // }
      else if (this.Device == "Teams") {
        $("#TeamsCallRate").css("display", "block");
        $("#dlscallType").val("");
        $("#CallRateCommon").css("display", "none");
        $("#TeamsCallRateSubmit").css("display", "block");
        $("#CallRateSkype").css("display", "none");
        $("#CallRateSubmit").css("display", "none");
        $("#CallrateDetailsSkype").css("display", "block");
        $("#CallrateDetailsCisco").css("display", "none");
        $("#divskype").css("display", "none");
        $("#uploadhr").css("display", "block");
        $("#divProjectDetailsCommonupload").css("display", "block");
        $("#divCallrateDetails").css("display", "none");
        $("#divCallrateDetails").css("display", "none");
        $("#TeamsBulkUpload").css("display", "none");
        $("#TeamsCallRateSubmit").css("display", "block");
        this.CallTypeTeamsFlag = false;
      }
      // // OnInit Methods Loading
      // this.LoadData();
      //this.dataLoader = false;
    } else {
      $("#AlertForAccess").css("display", "block");
      $("#CallRateCommon").css("display", "none");
      $("#TeamsCallRateSubmit").css("display", "none");
      $("#TeamsCallRate").css("display", "none");
      $("#CallRateSkype").css("display", "none");
      $("#CallRateSubmit").css("display", "none");
      $("#CallrateDetailsSkype").css("display", "none");
      $("#CallrateDetailsCisco").css("display", "none");
      $("#divCallrateDetails").css("display", "none");
      //$('#divCallrateDetails').css("display", 'none');
      $("#TeamsBulkUpload").css("display", "none");
      $("#TeamsCallRateSubmit").css("display", "none");
      //this.dataLoader = false;
    }
    //this.dataLoader = false;
  }

  LoadData() {
    this.capservice
      .GetVoiceAdminDetails(this.Device, "CallRate", this.country)
      .subscribe((data) => {
        //this.dataLoader = true;
        if (data.length >= 0) {
          this.successfulData = { callRates: data, selected: {} };
          this.allItems = data;
          this.setPage(1);
          this.GetCallRate();
          //this.dataLoader = false;
        }
        //this.dataLoader = false;
      });
    this.capservice
      .GetVoiceAdminDetails(this.Device, "CurrencyCoversionNames", this.country)
      .subscribe((data) => {
        //this.dataLoader = true;
        this.CurrencyList = data;
        this.dataLoader = false;
      });
  }
  TeamsLoadData() {
    if (this.Device == "Teams") {
      if (this.CallType == "International Calls") {
        this.capservice
          .GetVoiceAdminDetails(
            this.Device,
            "CallRateInternational",
            this.country
          )
          .subscribe((data) => {
            this.dataLoader = true;
            if (data.length >= 0) {
              this.successfulData = { TeamsCallRates: data, selected: {} };
              this.allItems = data;
              this.TeamssetPage(1);
              //  this.GetCallRate();
              this.dataLoader = false;
            }
            //this.dataLoader = false;
          });
      } else {
        this.capservice
          .GetVoiceAdminDetails(this.Device, "CallRateNational", this.country)
          .subscribe((data) => {
            this.dataLoader = true;
            if (data.length >= 0) {
              this.successfulData = { TeamsCallRates: data, selected: {} };
              this.allItems = data;
              this.TeamssetPage(1);
              //  this.GetCallRate();
              this.dataLoader = false;
            }
            //this.dataLoader = false;
          });
      }
    } else {
      this.capservice
        .GetVoiceAdminDetails(this.Device, "CallRate", this.country)
        .subscribe((data) => {
          this.dataLoader = true;
          if (data.length >= 0) {
            this.successfulData = { TeamsCallRates: data, selected: {} };
            this.allItems = data;
            this.setPage(1);
            this.GetCallRate();
            this.dataLoader = false;
          }
          //this.dataLoader = false;
        });
    }
    this.capservice
      .GetVoiceAdminDetails(this.Device, "CurrencyCoversionNames", this.country)
      .subscribe((data) => {
        //this.dataLoader = true;
        this.CurrencyList = data;
        //this.dataLoader = false;
      });
  }

  //download bulk upload template
  DownloadPoCreateTemplate() {
    this.dataLoader = true;
    if (this.CallType == "International Calls") {
      this.capservice.GetBulkTemplate(this.CallType).subscribe(
        (resultBlob: Blob) => {
          if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            // for IE
            (window.navigator as any).msSaveOrOpenBlob(
              resultBlob,
              "TeamsInternationalCallRate_BulkTemplate.xlsx"
            );
            this.dataLoader = false;
      }
      else{
        var link = document.createElement('a');
            link.href = window.URL.createObjectURL(resultBlob);
            link.download = "TeamsInternationalCallRate_BulkTemplate.xlsx";
            link.click();
            this.dataLoader = false;
          }
        },
        function (x) {
          console.log(x);
          alert("Acknowledgement failed");
          this.dataLoader = false;
    })
        }
  else if(this.CallType == "National Calls"){
    this.capservice.GetBulkTemplate(this.CallType).subscribe((resultBlob: Blob) => {
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) { // for IE
        (window.navigator as any).msSaveOrOpenBlob(resultBlob, "TeamsNationalCallRate_BulkTemplate.xlsx");
            this.dataLoader = false;
      }
      else{
        var link = document.createElement('a');
            link.href = window.URL.createObjectURL(resultBlob);
            link.download = "TeamsNationalCallRate_BulkTemplate.xlsx";
            link.click();
            this.dataLoader = false;
          }
        },
        function (x) {
          console.log(x);
          alert("Acknowledgement failed");
          this.dataLoader = false;
        }
      );
    }
    this.dataLoader = false;
  }
  GetCountryList() {
    this.capservice.CountryList(this.country, this.Type).subscribe((data) => {
      this.Countries = data;
    });
  }
  GetCallRate() {
    this.capservice
      .GetVoiceAdminDetails(this.Device, "CallRateDropdown", "N")
      .subscribe((data) => {
        this.CallRateList = data;
        this.dataLoader = false;
      });
  }
  DropdownValues() {
    this.capservice.DropdownValues("PeakList", "All").subscribe((data) => {
      this.PeakList = data;
      this.dataLoader = false;
    });
  }
  CiscoCallRateType(FieldName, DeviceType) {
    this.capservice.DropdownValues(FieldName, DeviceType).subscribe((data) => {
      this.CallTypeListCisco = data;
      this.dataLoader = false;
    });
  }
  TeamsCallRateType(FieldName, DeviceType) {
    this.capservice.DropdownValues(FieldName, DeviceType).subscribe((data) => {
      this.CallTypeListTeams = data;
      this.dataLoader = false;
    });
  }
  CallRateAdd() {
    debugger;
    this.dataLoader = true;
    var message = '';
    if (this.Device == 'Skype' || this.Device == 'Teams') {

      if ($('#grdfSourceCountries').val() == '') {
        message = "Please Select Source Country";
      }
      if ($("#grdfDestCountries").val() == "") {
        message = message + "\n" + "Please Select Destination Country";
      }
      if ($("#grdfdestcountrycode").val() == "") {
        message = message + "\n" + "Please Enter Destination Country Code";
      }
      if ($("#grdfCurrency").val() == "") {
        message = message + "\n" + "Please Select Currency";
      }
      if ($('#grdfInitMinutes').val() == '') {
        message = message + "\n" + "Please Enter Init Minutes";
      }
      if ($('#grdfInitMinutes2').val() == '') {
        message = message + "\n" + "Please Enter Init Minutes";
      }
      if ($('#grdfInitCharges').val() == '') {
        message = message + "\n" + "Please Enter Init Charges";
      }
      if ($('#grdfInitCharges2').val() == '') {
        message = message + "\n" + "Please Enter Init Charges";
      }
      if ($('#grdfAddMinutes').val() == '') {
        message = message + "\n" + "Please Enter Add Minutes";
      }
      if ($('#grdfAddMinutes2').val() == '') {
        message = message + "\n" + "Please Enter Add Minutes";
      }
      if ($('#grdfAddCharges').val() == '') {
        message = message + "\n" + "Please Enter Add Charges";
      }
      if ($('#grdfAddCharges2').val() == '') {
        message = message + "\n" + "Please Enter Add Charges";
      }
      // if (this.DestinationValues.length == 0) {
      //   message = message + "\n" + "Please Select Destination";
      // }
      // if ($('#grdfRateperMinute').val() == '') {
      //   message = message + "\n" + "Please Select RateperMinute";
      // }
      // if ($('#grdfCountries').val() == 'Mauritius') {
      //   if ($('#grdfSPeakList').val() == '') {
      //     message = message + "\n" + "Please Select Peak on/off";
      //   }
      // }
      //2023 National Cll Type Implementation
      this.CallRates.CallType = this.CallType;
    } else {
      if ($("#grdCCallRateName").val() == "") {
        message = "Please Enter Call Rate Name";
      }
      if ($("#grdCCountries").val() == "") {
        message = message + "\n" + "Please Select Country";
      }
      if ($("#grdCCallType").val() == "") {
        message = message + "\n" + "Please Select Call Type";
      }
      if ($("#grdCCurrency").val() == "") {
        message = message + "\n" + "Please Select Currency";
      }
      // if ($('#grdfInitMinutes').val() == '') {
      //   message = message + "\n" + "Please Enter Init Minutes";
      // }
      // if ($('#grdfInitCharges').val() == '') {
      //   message = message + "\n" + "Please Enter Init Charges";
      // }
      // if ($('#grdfAddMinutes').val() == '') {
      //   message = message + "\n" + "Please Enter Add Minutes";
      // }
      // if ($('#grdfAddCharges').val() == '') {
      //   message = message + "\n" + "Please Enter Add Charges";
      // }
      if (this.CallRates.InitMins == "") {
        message = message + "\n" + "Please Enter Init Minutes";
      }
      if (this.CallRates.InitCharge == "") {
        message = message + "\n" + "Please Enter Init Charges";
      }
      if (this.CallRates.AddMins == "") {
        message = message + "\n" + "Please Enter Add Minutes";
      }
      if (this.CallRates.AddCharge == "") {
        message = message + "\n" + "Please Enter Add Charges";
      }
      if (this.DestinationValues.length == 0) {
        message = message + "\n" + "Please Select Destination";
      }
      if ($("#grdCCountries").val() == "Mauritius") {
        if ($("#grdfCPeakList").val() == "") {
          message = message + "\n" + "Please Select Peak on/off";
        }
      }
    }
    if (message != "") {
      alert(message);
      this.dataLoader = false;
    }
    else {
      var DestinationNames = ''; var concString = '';
      for (var i = 0; i < this.DestinationValues.length; i++) {
        concString = concString + ',' + this.DestinationValues[i].label_id
      }

      // if (this.Device == 'Cisco') {
        this.CallRates.RatePerMinute = (concString.slice(1, concString.length));
      // this.CallRates.InitMins = (MYCASService.encryptedlogin(this.CallRates.InitMins)).ciphertext.toString(CryptoJS.enc.Base64);
      // this.CallRates.InitCharge = (MYCASService.encryptedlogin(this.CallRates.InitCharge)).ciphertext.toString(CryptoJS.enc.Base64);
      //   this.CallRates.AddMins = (MYCASService.encryptedlogin(this.CallRates.AddMins)).ciphertext.toString(CryptoJS.enc.Base64);
      //   this.CallRates.AddCharge = (MYCASService.encryptedlogin(this.CallRates.AddCharge)).ciphertext.toString(CryptoJS.enc.Base64);
      // }
      // else {
      //   this.CallRates.RatePerMinute = this.CallRates.RatePerMinute;
      // }
      this.CallRates.DeviceType = this.Device;
      this.CallRates.EnterpriseID = this.LoginEnterpriseID;

      this.CallRates.strType = "CallRate";
      // this.CallRates.token = MYCASService.tokenManager();

      this.capservice
        .InsertVoiceAdminDetails(this.CallRates)
        .subscribe((data) => {
          alert(data);
          this.clear();
          this.CallRates.currencyName = "";
          this.dataLoader = false;
        });
    }
  }
  TeamsCallRateAdd() {
    this.dataLoader = true;
    var message = '';
    if (this.Device == 'Teams') {
      // if ($('#grdfSourceCountries').val() == '') {
      //   message = "Please Select Source Country";
      // }
      // if ($('#grdfDestCountries').val() == '') {
      //   message = message + "\n" + "Please Select Destination Country";
      // }

      // if ($('#grdfCurrency').val() == '') {
      //   message = message + "\n" + "Please Select Currency";
      // }
      // if ($('#grdfInitMinutes').val() == '') {
      //   message = message + "\n" + "Please Enter Init Minutes";
      // }
      // if ($('#grdfInitCharges').val() == '') {
      //   message = message + "\n" + "Please Enter Init Charges";
      // }
      // if ($('#grdfAddMinutes').val() == '') {
      //   message = message + "\n" + "Please Enter Add Minutes";
      // }
      // if ($('#grdfAddCharges').val() == '') {
      //   message = message + "\n" + "Please Enter Add Charges";
      // }
      if (this.CallType == "National Calls") {
        if (
          $("#grdfdestcountrycity").val() == "" ||
          $("#grdfSourceCountries").val() == "" ||
          $("#grdfDestCountries").val() == "" ||
          $("#grdfCurrency").val() == "" ||
          $("#grdfInitMinutes").val() == "" ||
          $("#grdfInitCharges").val() == "" ||
          $("#grdfAddMinutes").val() == "" ||
          $("#grdfAddCharges").val() == ""
        ) {
          message = message + "\n" + "Please enter all the mandatory fields";
        }
        if ($("#grdfSourceCountries").val() != $("#grdfDestCountries").val()) {
          message =
            message + "\n" + "Source and destination country should be same";
        }
      } else {
        if (
          $("#grdfdestcountrycode").val() == "" ||
          $("#grdfSourceCountries").val() == "" ||
          $("#grdfDestCountries").val() == "" ||
          $("#grdfCurrency").val() == "" ||
          $("#grdfInitMinutes").val() == "" ||
          $("#grdfInitCharges").val() == "" ||
          $("#grdfAddMinutes").val() == "" ||
          $("#grdfAddCharges").val() == ""
        ) {
          message = message + "\n" + "Please enter all the mandatory fields";
        }
        if ($("#grdfSourceCountries").val() == $("#grdfDestCountries").val()) {
          message =
            message +
            "\n" +
            "Source and Destination country should not be same ";
        }
      }
    }

    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else {
      // this.TeamsCallRates.AdditionalMinutes = this.TeamsCallRates.AdditionalMinutes;
      // this.TeamsCallRates.AdditionalCharges = this.TeamsCallRates.AdditionalCharges;
      // this.TeamsCallRates.IntialMinutes =  this.TeamsCallRates.IntialMinutes;
      // this.TeamsCallRates.IntialCharges = this.TeamsCallRates.IntialCharges;
      //this.TeamsCallRates.ID = '1';
      this.TeamsCallRates.DeviceType = this.Device;
      this.TeamsCallRates.EnterpriseID = this.LoginEnterpriseID;
      this.TeamsCallRates.strType = "CallRate";
      this.TeamsCallRates.CallType = this.CallType;

      this.capservice
        .InsertVoiceAdminDetails(this.TeamsCallRates)
        .subscribe((data) => {
          alert(data);
          this.TeamsClear();
          //this.TeamsCallRates.currencyName = '';
          this.dataLoader = false;
        });
    }
  }
  EditCallRate(callRate) {
    this.successfulData.selected = Object.assign({}, callRate);

    this.capservice
      .GetVoiceAdminDetails(
        this.Device,
        "TeamsFetchCountrycity",
        this.successfulData.selected.DestinationCountry
      )
      .subscribe((data) => {
        this.DestinationSelectedCoutryCity = data;
        this.TeamsSelectedDestinationCountryCity = data.find(
          (item) => item.AreaCode === this.successfulData.selected.CityCode
        );
      });
  }

  GetDestinationCountrycd(dest) {
    this.capservice
      .GetVoiceAdminDetails(this.Device, "TeamsFetchCountryCode", dest)
      .subscribe((data) => {
        this.successfulData.selected.DestinationCountryCode =
          data[0]["CountryCode"];
      });
    if (this.CallType == "National Calls") {
      this.capservice
        .GetVoiceAdminDetails(this.Device, "TeamsFetchCountrycity", dest)
        .subscribe((data) => {
          this.DestinationSelectedCoutryCity = data;
          this.successfulData.selected.DestinationCountryCity = "";
        });
      this.successfulData.selected.CityCode = "";
    }
  }
  CallRateUpdate(idx) {
    debugger;
    this.dataLoader = true;
    var message = '';
    if (this.Device == 'Skype' || this.Device == 'Teams') {
      if ($('#grdCallRateName').val() == '') {
        message = "Please Enter Call Rate Name";
      }
      if ($("#grdCountries").val() == "") {
        message = message + "\n" + "Please Select Country";
      }
      if ($("#grdCallType").val() == "") {
        message = message + "\n" + "Please Select Call Type";
      }
      if ($("#grdCurrency").val() == "") {
        message = message + "\n" + "Please Select Currecny";
      }
      if ($("#grdInitMinutes").val() == "") {
        message = message + "\n" + "Please Enter Init Minutes";
      }
      if ($("#grdInitCharges").val() == "") {
        message = message + "\n" + "Please Enter Init Charges";
      }
      if ($("#grdAddMinutes").val() == "") {
        message = message + "\n" + "Please Enter Add Minutes";
      }
      if ($("#grdAddCharges").val() == "") {
        message = message + "\n" + "Please Enter Add Charges";
      }
      // if ($('#grdRateperMinute').val() == '') {
      //   message = message + "\n" + "Please Select RateperMinute";
      // }
      if ($("#grdCountries").val() == "Mauritius") {
        if ($("#grdfSEPeakList").val() == "") {
          message = message + "\n" + "Please Select Peak on/off";
        }
      }
    } else {
      if ($("#grdECCallRateName").val() == "") {
        message = "Please Enter Call Rate Name";
      }
      if ($("#grdECCountries").val() == "") {
        message = message + "\n" + "Please Select Country";
      }
      if ($("#grdECCallType").val() == "") {
        message = message + "\n" + "Please Select Call Type";
      }
      if ($("#grdECCurrency").val() == "") {
        message = message + "\n" + "Please Select Currecny";
      }
      if ($("#grdInitMinutes").val() == "") {
        message = message + "\n" + "Please Enter Init Minutes";
      }
      if ($("#grdInitCharges").val() == "") {
        message = message + "\n" + "Please Enter Init Charges";
      }
      if ($("#grdAddMinutes").val() == "") {
        message = message + "\n" + "Please Enter Add Minutes";
      }
      if ($("#grdAddCharges").val() == "") {
        message = message + "\n" + "Please Enter Add Charges";
      }
      if ($("#grdECCountries").val() == "Mauritius") {
        if ($("#grdfCEPeakList").val() == "") {
          message = message + "\n" + "Please Select Peak on/off";
        }
      }
    }
    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else {
      this.successfulData.callRates[idx] = Object.assign(
        {},
        this.successfulData.selected
      ); // angular.copy(this.successfulData.selected);
      this.successfulData.selected.ID1 =
        this.successfulData.selected.Id.toString();
      this.successfulData.selected.Id = this.successfulData.selected.Id;
      this.successfulData.selected.CallRateName =
        this.successfulData.selected.CallRateName;
      this.successfulData.selected.Country =
        this.successfulData.selected.Country;
      this.successfulData.selected.CallType =
        this.successfulData.selected.CallType;
      this.successfulData.selected.Currency =
        this.successfulData.selected.Currency;
      this.successfulData.selected.DeviceType = this.Device;
      this.successfulData.selected.strType = "CallRate";
      this.successfulData.selected.EnterpriseID = this.LoginEnterpriseID;
      this.successfulData.selected.currencyId =
        this.successfulData.selected.currencyId.toString();

      // if (this.Device == 'Cisco') {
      this.successfulData.selected.destinationId =
        this.successfulData.selected.destinationId.toString();
      this.successfulData.selected.destinationName =
        this.successfulData.selected.destinationName;
      this.successfulData.selected.RatePerMinute =
        this.successfulData.callRates[idx].destinationId.toString();
      this.successfulData.selected.InitMins =
        this.successfulData.selected.InitMins.toString();
      this.successfulData.selected.InitCharge =
        this.successfulData.selected.InitCharge.toString();
      this.successfulData.selected.AddMins =
        this.successfulData.selected.AddMins.toString();
      this.successfulData.selected.AddCharge =
        this.successfulData.selected.AddCharge.toString();
      //}
      // else if(this.Device == 'Teams')
      // {
      //   this.successfulData.selected.InitMins = this.successfulData.selected.InitMins.toString();
      //   this.successfulData.selected.InitCharge = this.successfulData.selected.InitCharge.toString();
      //   this.successfulData.selected.AddMins = this.successfulData.selected.AddMins.toString();
      //   this.successfulData.selected.AddCharge = this.successfulData.selected.AddCharge.toString();
      // }
      // else {
      //   this.successfulData.selected.RatePerMinute = this.successfulData.selected.RatePerMinute.toString();
      // }
      //this.successfulData.selected.token = MYCASService.tokenManager();

      this.capservice
        .UpdateVoiceAdminDetails(this.successfulData.selected)
        .subscribe((data) => {
          alert(data);
          this.clear();
          this.dataLoader = false;
        });
    }
  }
  TeamsCallRateUpdate(idx) {
    this.dataLoader = true;
    var message = '';
    if (this.Device == 'Teams') {
      if(this.CallType == 'National Calls'){

        if (($('#grddestcountrycity').val() == '')||($('#grdSourceCountries').val() == '')||($('#grdDestinationCountries').val() == '') || ($('#grdCurrency').val() == '')
        || ($('#grdInitMinutes').val() == '') || ($('#grdInitCharges').val() == '') || ($('#grdAddMinutes').val() == '') ||  ($('#grdAddCharges').val() == '')) {
          message = message + "\n" + "Please enter all the mandatory fields";
        }
        if (
          $("#grdSourceCountries").val() != $("#grdDestinationCountries").val()
        ) {
          message =
            message + "\n" + "Source and destination country should be same";
        }
      } else {
        if (
          $("#grddestcountrycode").val() == "" ||
          $("#grdSourceCountries").val() == "" ||
          $("#grdDestinationCountries").val() == "" ||
          $("#grdCurrency").val() == "" ||
          $("#grdInitMinutes").val() == "" ||
          $("#grdInitCharges").val() == "" ||
          $("#grdAddMinutes").val() == "" ||
          $("#grdAddCharges").val() == ""
        ) {
          message = message + "\n" + "Please enter all the mandatory fields";
        }
        if (
          $("#grdSourceCountries").val() == $("#grdDestinationCountries").val()
        ) {
          message =
            message +
            "\n" +
            "Source and Destination country should not be same ";
        }
      }
    }

    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else {
      // this.successfulData.callRates[idx] = Object.assign({}, this.successfulData.selected);// angular.copy(this.successfulData.selected);
      this.successfulData.selected.ID =
        this.successfulData.selected.ID.toString();
      this.successfulData.selected.CallType =
        this.successfulData.selected.CallType;
      this.successfulData.selected.Currency =
        this.successfulData.selected.Currency;
      this.successfulData.selected.DeviceType = this.Device;
      this.successfulData.selected.strType = "CallRate";
      this.successfulData.selected.EnterpriseID = this.LoginEnterpriseID;
      this.successfulData.selected.InitMins =
        this.successfulData.selected.InitMins.toString();
      this.successfulData.selected.InitCharge =
        this.successfulData.selected.InitCharge.toString();
      this.successfulData.selected.AddMins =
        this.successfulData.selected.AddMins.toString();
      this.successfulData.selected.AddCharge =
        this.successfulData.selected.AddCharge.toString();
      this.successfulData.selected.CallType = this.CallType;

      this.capservice
        .UpdateVoiceAdminDetails(this.successfulData.selected)
        .subscribe((data) => {
          alert(data);
          this.TeamsClear();
          this.dataLoader = false;
        });
    }
  }
  ShowData() {
    //Paginator.page = 0;
    this.dataLoader = true;
    if ($("#txtCallRateName").val() == "" && $("#dlstCountry").val() == "") {
      $("#divCallrateDetails").css("display", "none");
      alert("Please select value to search");
      this.dataLoader = false;
    } else {
      var Country = "";
      var CallRateName = $('#txtCallRateName').val() == '' ? 'N' : $('#txtCallRateName').val();
      if (this.Role != 'Global Admin') {
        Country = $('#dlstCountry').val() == '' ? this.Country : $('#dlstCountry').val();
      }
      else {
        Country = $('#dlstCountry').val() == '' ? 'N' : $('#dlstCountry').val();

      }
      var CallType = $('#dlstCallType').val() == '' ? 'N' : $('#dlstCallType').val();
      var type = "CallRate"

      if (this.Device == 'Teams') {
        this.capservice.SearchDetailsTeamsRate(CallRateName, Country, 'N', this.Device, type).subscribe(data => {
            this.dataLoader = true;
            if (data.length > 0) {
              this.successfulData = { callRates: data, selected: {} };
              this.allItems = data;
              // initialize to page 1
              this.setPage(1);
              $("#divCallrateDetails").css("display", "block");
              this.dataLoader = false;
            } else {
              alert("No Records Found");
              $("#divCallrateDetails").css("display", "none");
              this.dataLoader = false;
            }
          });
      } else {
        this.capservice
          .SearchDetails(CallRateName, Country, "N", this.Device, type)
          .subscribe((data) => {
            this.dataLoader = true;
            if (data.length > 0) {
              this.successfulData = { callRates: data, selected: {} };
              this.allItems = data;
              // initialize to page 1
              this.setPage(1);
              $("#divCallrateDetails").css("display", "block");
              this.dataLoader = false;
            } else {
              alert("No Records Found");
              $("#divCallrateDetails").css("display", "none");
              this.dataLoader = false;
            }
          });
      }
    }
  }
  TeamsShowData() {
    this.dataLoader = true;
    if (
      ($("#dlscallType").val() == "" || $("#dlscallType").val() == null) &&
      $("#dlstSourceCountry").val() == ""
    ) {
      $("#divCallrateDetails").css("display", "none");
      alert("Please select value to search");
      this.dataLoader = false;
    } else {
      var Country = "";
      var CallRateName = $('#dlscallType').val() == '' ? 'N' : $('#dlscallType').val();
      if (this.Role != 'Global Admin') {
        Country = $('#dlstSourceCountry').val() == '' ? this.Country : $('#dlstSourceCountry').val();
      }
      else {
        Country = $('#dlstSourceCountry').val() == '' ? 'N' : $('#dlstSourceCountry').val();

      }
      var CallType = $('#dlscallType').val() == '' ? 'N' : $('#dlscallType').val();
      var type = "CallRate"

      if (this.Device == 'Teams') {
        this.capservice.SearchDetailsTeamsRate(CallRateName, Country, 'N', this.Device, type).subscribe(data => {
            this.dataLoader = true;
            if (data.length > 0) {
              this.successfulData = { TeamsCallRates: data, selected: {} };
              this.allItems = data;
              // initialize to page 1
              this.TeamssetPage(1);
              $("#divCallrateDetails").css("display", "block");
              this.dataLoader = false;
            } else {
              alert("No Records Found");
              $("#divCallrateDetails").css("display", "none");
              this.dataLoader = false;
            }
          });
      }
    }
  }
  ExportToBulkExcel() {
    this.dataLoader = true;
          var Country = "";
          var ReportName = 'CallRates.xlsx';

          var CallRateName = $('#txtCallRateName').val() == '' ? 'N' : $('#txtCallRateName').val();
          if (this.Role != 'Global Admin') {
            Country = $('#dlstCountry').val() == '' ? this.Country : $('#dlstCountry').val();
    }
          else {
            Country = $('#dlstCountry').val() == '' ? 'N' : $('#dlstCountry').val();    
          }
          var CallType = $('#dlstCallType').val() == '' ? 'N' : $('#dlstCallType').val();
          var type = "CallRate"

    this.capservice
      .SearchDetailsBulkDownload(CallRateName, Country, "N", this.Device, type)
      .subscribe(
        (data: Blob) => {
          this.dataLoader = true;
          if (data.size > 0) {
            if (
              window.navigator &&
              (window.navigator as any).msSaveOrOpenBlob
            ) {
              // for IE
              (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
              this.dataLoader = false;
            }
              else{
                var link = document.createElement('a');
              link.href = window.URL.createObjectURL(data);
              link.download = ReportName;
              link.click();
              this.dataLoader = false;
            }
          } else {
            alert("No Records Found");
            this.dataLoader = false;
          }
        },
        function (x) {
          console.log(x);
          this.dataLoader = false;
          alert("Acknowledgement failed");
        }
      );
  }
  TeamsExportToBulkExcel() {
    this.dataLoader = true;
      var Country = "";
      var ReportName = 'CallRates.xlsx';

      var CallRateName = $('#dlscallType').val() == '' ? 'N' : $('#dlscallType').val();
      if (this.Role != 'Global Admin') {
        Country = $('#dlstSourceCountry').val() == '' ? this.Country : $('#dlstSourceCountry').val();
    }
      else {
        Country = $('#dlstSourceCountry').val() == '' ? 'N' : $('#dlstSourceCountry').val();    
      }
      var CallType = $('#dlscallType').val() == '' ? 'N' : $('#dlscallType').val();
      var type = "CallRate"

    this.capservice
      .SearchDetailsBulkDownload(CallRateName, Country, "N", this.Device, type)
      .subscribe(
        (data: Blob) => {
          this.dataLoader = true;
          if (data.size > 0) {
            if (
              window.navigator &&
              (window.navigator as any).msSaveOrOpenBlob
            ) {
              // for IE
              (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
              this.dataLoader = false;
        }
          else{
            var link = document.createElement('a');
              link.href = window.URL.createObjectURL(data);
              link.download = ReportName;
              link.click();
              this.dataLoader = false;
            }
          } else {
            alert("No Records Found");
            this.dataLoader = false;
          }
        },
        function (x) {
          console.log(x);
          this.dataLoader = false;
          alert("Acknowledgement failed");
        }
      );
  }
  DeleteCiscoCallRate(callRate) {
    this.dataLoader = true;
    // this.successfulData.selected.ID1 = callRate.Id;
    // this.successfulData.selected.Id = callRate.Id;
    // this.successfulData.selected.destinationId =callRate.destinationId;
    // this.successfulData.selected.DeviceType = "Cisco";
    // this.successfulData.selected.strType = "DeleteCallRate";
    // this.successfulData.selected.EnterpriseID = this.LoginEnterpriseID;
    //this.successfulData.selected.token = MYCASService.tokenManager();

    callRate.DeviceType = "Cisco";
    callRate.strType = "DeleteCallRate";
    callRate.EnterpriseID = this.LoginEnterpriseID;
    callRate.AddCharge = callRate.AddCharge.toString();
    callRate.AddMins = callRate.AddMins.toString();
    callRate.InitCharge = callRate.InitCharge.toString();
    callRate.InitMins = callRate.InitMins.toString();
    callRate.destinationId = callRate.destinationId.toString();
    callRate.currencyId = callRate.currencyId.toString();
    //this.successfulData.selected.token = MYCASService.tokenManager();

    this.capservice.UpdateVoiceAdminDetails(callRate).subscribe((data) => {
      alert(data);
      this.clear();
      this.dataLoader = false;
    });
  }
  DeleteCallRate(callRate) {
    this.dataLoader = true;
    callRate.DeviceType = "Teams";
    callRate.strType = "DeleteCallRate";
    callRate.EnterpriseID = this.LoginEnterpriseID;
    callRate.ID = callRate.ID.toString();
    callRate.AddCharge = callRate.AddCharge.toString();
    callRate.AddMins = callRate.AddMins.toString();
    callRate.InitCharge = callRate.InitCharge.toString();
    callRate.InitMins = callRate.InitMins.toString();

    this.capservice.UpdateVoiceAdminDetails(callRate).subscribe((data) => {
      alert(data);
      this.TeamsClear();
      this.dataLoader = false;
    });
  }
  GetDestinationCountryCode() {
    this.capservice
      .GetVoiceAdminDetails(
        this.Device,
        "TeamsFetchCountryCode",
        this.TeamsCallRates.DestinationCountry
      )
      .subscribe((data) => {
        this.TeamsCallRates.DestinationCountryCode = data[0]["CountryCode"];
      });
    if (this.CallType == "National Calls") {
      this.GetdestCountryCity();
    }
  }
  GetdestCountryCity() {
    this.capservice
      .GetVoiceAdminDetails(
        this.Device,
        "TeamsFetchCountrycity",
        this.TeamsCallRates.DestinationCountry
      )
      .subscribe((data) => {
        this.DestinationCoutryCity = data;
        this.TeamsCallRates.CityCode = "";
        //  this.successfulData.selected.DestinationCountryCity = '';
      });
    // this.successfulData.selected.CityCode = '';
  }
  clear() {
    this.dataLoader = true;
    $('#grdfCallRateName').val('');
    $('#grdfCountries').val('');
    $('#grdfCallType').val('');
    $('#grdfActive').val('');
    $('#grdfCurrency').val('');
    $('#grdCCallRateName').val('');
    $('#grdCCountries').val('');
    $('#grdCCallType').val('');
    $('#grdCCurrency').val('');
    $('#grdECCallRateName').val('');
    $('#grdECCountries').val('');
    $('#grdECCallType').val('');
    $('#grdECCurrency').val('');
    $('#grdfRateperMinute').val('');
    $('#grdfInitMinutes').val('');
    $('#grdfInitMinutes2').val('');
    $('#grdfInitCharges').val('');
    $('#grdfInitCharges2').val('');
    $('#grdfAddMinutes').val('');
    $('#grdfAddMinutes2').val('');
    $('#grdfAddCharges').val('');
    $('#grdfAddCharges2').val('');
    $('#grdCallRateName').val('');
    $('#grdCountries').val('');
    $('#grdCallType').val('');
    $('#grdActive').val('');
    $('#grdCurrency').val('');
    $('#grdGateway').val('');
    $('#grdRateperMinute').val('');
    $('#grdInitMinutes').val('');
    $('#grdInitCharges').val('');
    $('#grdAddMinutes').val('');
    $('#grdAddCharges').val('');
    $('#grdfInitMinutes1').val('');
    $('#grdfInitCharges1').val('');
    $('#grdfAddMinutes1').val('');
    $('#grdfAddCharges1').val('');
    $('#txtCallRateName').val('');
    $('#dlstCountry').val('');
    $('#dlscallType').val('');
    $('#dlstSourceCountry').val('');    
    $('#grdfSPeakList').val('');
    $('#grdfCPeakList').val('');
    $('#grdfSourceCountries').val('');
    $('#grdfDestCountries').val('');
    $('#grdfdestcountrycode').val('');
    $('#grdfdestcountrycity').val('');
    this.CallRates.InitMins = '';
    this.CallRates.InitCharge ='';
    this.CallRates.AddMins = '';
    this.CallRates.AddCharge = '';

    this.CallRateName = "";
    $("#divCallrateDetails").css("display", "block");
    this.LoadData();
    //this.TeamsLoadData();
    this.DestinationList = [];
    this.DestinationValues = [];
    this.Destination();
    //this.dataLoader = false;
  }
  TeamsClear() {
    this.dataLoader = true;
    $('#grdfSourceCountries').val('');
    $('#grdfDestCountries').val('');
    $('#grdfdestcountrycode').val('');
    $('#grdfdestcountrycity').val('');
    $('#grdfInitMinutes').val('');
    $('#grdfInitMinutes2').val('');
    $('#grdfInitCharges').val('');
    $('#grdfInitCharges2').val('');
    $('#grdfAddMinutes').val('');
    $('#grdfAddMinutes2').val('');
    $('#grdfAddCharges').val('');
    $('#grdfAddCharges2').val('');
    $('#grdfCityCode').val('');
    $('#grdfCurrency').val('');
    $('#grdSourceCountries').val('');
    $('#grdDestCountries').val('');
    $('#grddestcountrycode').val('');
    $('#grddestcountrycity').val('');
    $('#grdInitMinutes').val('');
    $('#grdInitCharges').val('');
    $('#grdAddMinutes').val('');
    $('#grdAddCharges').val('');
    $('#grdCityCode').val('');
    this.DestinationCountryCode = [];
    this.DestinationCoutryCity = [];
    this.TeamsCallRates.CityCode = "";
    this.TeamsCallRates.DestinationCountryCode = "";
    this.TeamsCallRates.DestinationCountryCity = "";

    this.TeamsLoadData();
    $("#divCallrateDetails").css("display", "block");
    this.dataLoader = false;
  }
  TeamsCallRateClear() {
    $("#dlscallType").val("");
    $("#dlstSourceCountry").val("");
    $("#divCallrateDetails").css("display", "none");
    this.CallTypeTeamsFlag = false;
    // this.TeamsClear();
    $("#TeamsBulkUpload").css("display", "none");
    $("#TeamsCallRateSubmit").css("display", "block");
  }
  ClearDevice() {
    //this.dataLoader = true;
    $('#grdfCallRateName').val('');
    $('#grdfCountries').val('');
    $('#grdfCallType').val('');
    $('#grdfActive').val('');
    $('#grdfCurrency').val('');
    $('#grdCCallRateName').val('');
    $('#grdCCountries').val('');
    $('#grdCCallType').val('');
    $('#grdCCurrency').val('');
    $('#grdECCallRateName').val('');
    $('#grdECCountries').val('');
    $('#grdECCallType').val('');
    $('#grdECCurrency').val('');
    $('#grdfRateperMinute').val('');
    $('#grdfInitMinutes').val('');
    $('#grdfInitMinutes2').val('');
    $('#grdfInitCharges').val('');
    $('#grdfInitCharges2').val('');
    $('#grdfAddMinutes').val('');
    $('#grdfAddMinutes2').val('');
    $('#grdfAddCharges').val('');
    $('#grdfAddCharges2').val('');
    $('#grdCallRateName').val('');
    $('#grdCountries').val('');
    $('#grdCallType').val('');
    $('#grdActive').val('');
    $('#grdCurrency').val('');
    $('#grdGateway').val('');
    $('#grdRateperMinute').val('');
    $('#grdInitMinutes').val('');
    $('#grdInitCharges').val('');
    $('#grdAddMinutes').val('');
    $('#grdAddCharges').val('');
    $('#grdfInitMinutes1').val('');
    $('#grdfInitCharges1').val('');
    $('#grdfAddMinutes1').val('');
    $('#grdfAddCharges1').val('');
    $('#txtCallRateName').val('');
    $('#dlstCountry').val('');
    $('#grdfCPeakList').val('');
    this.CallRateName = '';
    // this.dataLoader = false;
  }
  reset() {
    this.dataLoader = true;
    this.successfulData.selected = {};
    this.dataLoader = false;
  }
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);
    // get current page of items
    this.successfulData.callRates = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  TeamssetPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);
    // get current page of items
    this.successfulData.TeamsCallRates = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setFile(event) {
    this.theFile = event.target.files[0];
  }
  addFileDetails() {
    debugger;
    this.dataLoader = true;
    var file = this.addModifyHostNamesForm.controls.inputFile.value;
      var ext = file.split('.').pop().toLowerCase();
      if (file == '') {
          alert('Please Upload The Template');
      this.dataLoader = false;
      return;
    }
    if (ext != "xls" && ext != "xlsx") {
      alert("Please upload bulk template in correct format");
      $("#fileControl").val("");
      this.dataLoader = false;
      }
      else {
          var formData = new FormData();
          formData.append('file', this.theFile);
          this.capservice.TeamsCallRateBulkUploadHostTemplate(this.CallType,formData).subscribe(data => {
              this.addModifyHostNamesForm.controls.inputFile.setValue('');
          alert(data);
          this.TeamsLoadData();
          this.dataLoader = false;
        });
    }
  }

  CallTypeAction() {
    this.CallType = "";
    this.CallType = this.dlscallType;
    if (this.CallType != "") {
      if (this.CallType == "International Calls") {
        this.CallTypeInterNationalFlag = true;
        this.CallTypeNationalFlag = false;
      } else if (this.CallType == "National Calls") {
        this.CallTypeInterNationalFlag = false;
        this.CallTypeNationalFlag = true;
      }
      this.CallTypeTeamsFlag = true;
      this.TeamsClear();
      $("#TeamsBulkUpload").css("display", "block");
      $("#TeamsCallRateSubmit").css("display", "block");
    } else {
      this.CallTypeTeamsFlag = false;
      $("#divCallrateDetails").css("display", "none");
      $("#TeamsBulkUpload").css("display", "none");
      $("#TeamsCallRateSubmit").css("display", "none");
    }
  }
  GetCityCd(f: any) {
    this.successfulData.selected.CityCode =
      this.DestinationSelectedCoutryCity.find(
        (item) => item.SlNo === f.SlNo
      ).AreaCode;
    this.successfulData.selected.DestinationCountryCity = f.LOcation;
  }
  GetCityCode(e: any) {
    this.TeamsCallRates.CityCode = this.DestinationCoutryCity.find(
      (item) => item.SlNo === e.SlNo
    ).AreaCode;
    this.TeamsCallRates.DestinationCountryCity = e.LOcation;
  }
}
